import Web3 from "web3";
import { DEFAULT_RPC } from "./constant";

export const getWeb3 = () => {
  return new Web3(DEFAULT_RPC);
}
